export default __webpack_public_path__ + "static/media/fortune_quest.40f800ce.webp";